export default __webpack_public_path__ + "static/media/frg--outdoor-cinema.60983737.png";